import { __spreadArrays } from "tslib";
import { sortByQuestion } from '../utils/sort-by-question';
var FaqSpotBaseController = (function () {
    function FaqSpotBaseController($scope, productContextService, siteLanguage) {
        this.$scope = $scope;
        this.productContextService = productContextService;
        this.siteLanguage = siteLanguage;
        this.showMoreAvailable = false;
        this.showAllAvailable = false;
        this.showLessAvailable = false;
        this.showAllFaqAvailable = false;
        this.trackLimit = 5;
        this.$scope.limit = 0;
        this.$scope.faqItems = [];
    }
    FaqSpotBaseController.prototype.$onInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) { _this.$scope.group = group; });
        this.$scope.showAllAvailable = function () {
            return _this.showAllAvailable;
        };
        this.$scope.showMore = function (sortItemsByQuestion) {
            if (sortItemsByQuestion === void 0) { sortItemsByQuestion = true; }
            if (sortItemsByQuestion) {
                _this.setSortItemsByQuestion();
            }
            if (!_this.$scope.initialFaqItems) {
                _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.faqItems);
            }
            _this.trackLimit += 5;
            if (_this.trackLimit < _this.$scope.initialFaqItems.length) {
                _this.$scope.limit = _this.trackLimit;
                _this.showMoreAvailable = true;
                _this.showLessAvailable = false;
                _this.showAllFaqAvailable = true;
            }
            else {
                _this.$scope.limit = _this.$scope.initialFaqItems.length;
                _this.showMoreAvailable = false;
                _this.showLessAvailable = true;
                _this.showAllFaqAvailable = false;
            }
            _this.showAllAvailable = true;
        };
        this.$scope.showAllFaq = function (sortItemsByQuestion) {
            if (sortItemsByQuestion === void 0) { sortItemsByQuestion = true; }
            if (sortItemsByQuestion) {
                _this.setSortItemsByQuestion();
            }
            if (!_this.$scope.initialFaqItems) {
                _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.faqItems);
            }
            _this.$scope.limit = _this.$scope.initialFaqItems.length;
            _this.showMoreAvailable = false;
            _this.showLessAvailable = true;
        };
        this.$scope.showMoreAvailable = function () {
            var faqs = _this.$scope.allFaqItems || _this.$scope.faqItems;
            return _this.showMoreAvailable && _this.$scope.limit < faqs.length;
        };
        this.$scope.showLess = function () {
            _this.$scope.faqItems = __spreadArrays(_this.$scope.initialFaqItems);
            _this.$scope.limit = _this.$scope.initialLimit;
            _this.showMoreAvailable = true;
            _this.showAllAvailable = false;
            _this.showLessAvailable = false;
            _this.trackLimit = 5;
        };
        this.$scope.showLessAvailable = function () {
            return _this.showLessAvailable;
        };
        this.$scope.getViewAllUrl = function () {
            if (typeof _this.$scope.group !== 'object' || _this.$scope.group === null) {
                return undefined;
            }
            return _this.$scope.group.supportPageUrl + "#/FAQ#" + _this.$scope.group.sku;
        };
    };
    FaqSpotBaseController.prototype.setSortItemsByQuestion = function () {
        var faqs = this.$scope.allFaqItems || this.$scope.faqItems;
        this.$scope.faqItems = sortByQuestion(faqs, this.siteLanguage);
    };
    return FaqSpotBaseController;
}());
export { FaqSpotBaseController };
